import { useVenueSettings } from "../hooks/venue-settings-context/use-venue-settings";

export function RoleDisplay({
	label,
	value,
}: {
	label?: string | null;
	value?: string | null;
} & Record<string, unknown>) {
	const {
		staffing: { staffRoles },
	} = useVenueSettings();

	if (label) {
		return <>{label}</>;
	}

	const role = staffRoles.find((r) => r.key === value);

	if (!role) return <>{label || value}</>;

	return <>{role.label}</>;
}
